"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  createLogger: () => createLogger,
  isDebugEnabled: () => isDebugEnabled,
  listDebugModules: () => listDebugModules,
  setDebugEnabled: () => setDebugEnabled
});
module.exports = __toCommonJS(index_exports);
var PREFIX = "debug:";
function hasLocalStorage() {
  try {
    return typeof localStorage !== "undefined" && localStorage !== null;
  } catch {
    return false;
  }
}
function getProcessEnv() {
  try {
    if (typeof process !== "undefined" && process.env !== void 0) {
      return process.env;
    }
  } catch {
  }
  return null;
}
function moduleToEnvKey(module2) {
  return "DEBUG_" + module2.replace(/[:-]/g, "_").toUpperCase();
}
function isEnabled(module2) {
  const key = `${PREFIX}${module2}`;
  if (hasLocalStorage()) {
    const val = localStorage.getItem(key);
    if (val === null) {
      localStorage.setItem(key, "1");
      return true;
    }
    return val === "1";
  }
  const env = getProcessEnv();
  if (env) {
    const envKey = moduleToEnvKey(module2);
    const val = env[envKey];
    if (val === void 0) return true;
    return val === "1";
  }
  return true;
}
function createLogger(module2) {
  return {
    log(...args) {
      if (isEnabled(module2)) {
        console.log(`[${module2}]`, ...args);
      }
    },
    warn(...args) {
      if (isEnabled(module2)) {
        console.warn(`[${module2}]`, ...args);
      }
    },
    error(...args) {
      if (isEnabled(module2)) {
        console.error(`[${module2}]`, ...args);
      }
    }
  };
}
function setDebugEnabled(module2, enabled) {
  const key = `${PREFIX}${module2}`;
  if (hasLocalStorage()) {
    localStorage.setItem(key, enabled ? "1" : "0");
  } else {
    const env = getProcessEnv();
    if (env) {
      env[moduleToEnvKey(module2)] = enabled ? "1" : "0";
    }
  }
}
function isDebugEnabled(module2) {
  const key = `${PREFIX}${module2}`;
  if (hasLocalStorage()) {
    const val = localStorage.getItem(key);
    return val === null ? true : val === "1";
  }
  const env = getProcessEnv();
  if (env) {
    const envKey = moduleToEnvKey(module2);
    const val = env[envKey];
    return val === void 0 ? true : val === "1";
  }
  return true;
}
function listDebugModules() {
  const result = [];
  if (hasLocalStorage()) {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(PREFIX)) {
        const module2 = key.slice(PREFIX.length);
        result.push({ module: module2, enabled: localStorage.getItem(key) === "1" });
      }
    }
  } else {
    const env = getProcessEnv();
    if (env) {
      for (const envKey of Object.keys(env)) {
        if (envKey.startsWith("DEBUG_")) {
          const module2 = envKey.slice("DEBUG_".length).toLowerCase().replace(/_/g, "-");
          const val = env[envKey];
          result.push({ module: module2, enabled: val === "1" });
        }
      }
    }
  }
  return result.sort((a, b) => a.module.localeCompare(b.module));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  createLogger,
  isDebugEnabled,
  listDebugModules,
  setDebugEnabled
});
